import { Col, Row } from "antd";
import { useTranslation } from "react-i18next";
import { Wrapper } from "..";
import MostUsedItems from "./content/most-used-item";
import MostUser from "./content/most-user";

const WorkSpaceDashboard = () => {
  const { t } = useTranslation();
  return (
    <Wrapper>
      <Row gutter={[14, 14]} className="h-full w-full">
        <Col span={24} style={{fontSize: 18, fontWeight: 600}}>{t("work-space", { ns: "menu" })}</Col>
        <Col md={24} lg={24} xl={12}>
          <MostUser />
        </Col>
        <Col md={24} lg={24} xl={12}>
          <MostUsedItems />
        </Col>
      </Row>
    </Wrapper>
  );
};

export default WorkSpaceDashboard;
